import Vue from 'vue';
import Component from 'vue-class-component';
import {isCountryInNorthAmerica} from '../../CountryRestriction/CountryRestrictionUtility';
import ChatForm from './ChatForm.vue';

@Component({
  props: {
    image: String,
    imageNotAvailable: String,
    url: String,
  },
  components: {
    ChatForm,
  },
})
export default class ChatBox extends Vue {
  image?: string;
  imageNotAvailable?: string;
  url?: string;
  chatAvailable: boolean = false;

  get isCountryAllowed(): boolean {
    return isCountryInNorthAmerica();
  }

  async isChatBoxAvailable(): Promise<boolean> {
    if (this.url) {
      const agent = await fetch(this.url).then((response) => response.json());
      if ('error' in agent && 'status' in agent) {
        console.error(agent);
      }
      return agent.available || false;
    }
    return false;
  }

  async mounted() {
    if (this.isCountryAllowed) {
      this.chatAvailable = await this.isChatBoxAvailable();
    }
  }
}
